import { useEffect, useMemo } from 'react';
import ReactGA from 'react-ga4';
import { InitOptions } from 'react-ga4/types/ga4';

type UseGoogleAnalyticsProps = {
  trackingId?: string;
  isReady?: boolean;
};

const TRACKING_ID = process.env.VITE_ANALYTICS_CODE;

export const useGoogleAnalytics = (props: UseGoogleAnalyticsProps = { isReady: true }) => {
  const { isReady, trackingId } = props;
  const trackers = useMemo(() => {
    if (isReady) {
      const gaOptions = { titleCase: false };
      const trackingIds = [TRACKING_ID, trackingId];
      return trackingIds.filter(Boolean).map((trackingId) => ({
        trackingId,
        gaOptions,
        debug: false,
      })) as InitOptions[];
    }
    return [];
  }, [isReady, trackingId]);

  useEffect(() => {
    if (TRACKING_ID && trackers.length) {
      ReactGA.initialize(trackers);
    }
  }, [trackers]);
};

// Component that can be used when it's hard to place the hook under the react-router
export const GoogleAnalyticsHandler = (props: UseGoogleAnalyticsProps) => {
  useGoogleAnalytics(props);

  return null;
};
